module.exports = __webpack_public_path__ + "static/img/brand-8.be5ec85.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand-8.png
// module id = uziB
// module chunks = 0